/* ALLRED theme script */
(function(){
"use strict";
var A=window.ALLRED||{};
function waUrl(msg){return "https://wa.me/"+String(A.wa||"").replace(/\D/g,"")+"?text="+encodeURIComponent(msg)}
function $(s,c){return (c||document).querySelector(s)}
function $$(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))}

/* ---------- overlays: mobile menu + search ---------- */
var lastFocus=null;
function openOverlay(id){
  var el=document.getElementById(id); if(!el) return;
  lastFocus=document.activeElement; el.hidden=false;
  document.documentElement.style.overflow="hidden";
  var f=el.querySelector("input[type=search],input,button,a"); if(f) setTimeout(function(){f.focus()},30);
}
function closeOverlays(){
  var any=false;
  $$("[data-overlay]").forEach(function(el){if(!el.hidden){any=true;el.hidden=true}});
  document.documentElement.style.overflow="";
  if(any&&lastFocus&&lastFocus.focus) lastFocus.focus();
}

/* ---------- toast ---------- */
var toastT;
function toast(t){
  var el=$("#allred-toast");
  if(!el){el=document.createElement("div");el.id="allred-toast";el.className="toast";el.setAttribute("role","status");document.body.appendChild(el)}
  el.textContent=t; el.hidden=false; clearTimeout(toastT); toastT=setTimeout(function(){el.hidden=true},2600);
}

/* ---------- wishlist (saved in the visitor's browser) ---------- */
function getWish(){try{return JSON.parse(localStorage.getItem("allred:wish")||"[]")}catch(e){return []}}
function setWish(w){try{localStorage.setItem("allred:wish",JSON.stringify(w))}catch(e){}}
function paintWish(){var w=getWish();$$("[data-wish]").forEach(function(b){b.setAttribute("aria-pressed",w.indexOf(b.dataset.wish)>-1)})}

document.addEventListener("click",function(e){
  var t;
  if((t=e.target.closest("[data-open]"))){e.preventDefault();closeOverlays();openOverlay(t.dataset.open);return}
  if(e.target.closest("[data-close]")){e.preventDefault();closeOverlays();return}
  if((t=e.target.closest("[data-wish]"))){
    e.preventDefault();
    var w=getWish(), i=w.indexOf(t.dataset.wish);
    if(i>-1) w.splice(i,1); else w.push(t.dataset.wish);
    setWish(w); paintWish(); toast(i>-1?"Removed from your wishlist":"Saved to your wishlist"); return;
  }
  if((t=e.target.closest("[data-q]"))){var inp=$("#search-ov input[name=q]");if(inp){inp.value=t.dataset.q;inp.form.submit()}return}
  if((t=e.target.closest("[data-chip]"))){
    var k=t.dataset.chip;
    $$("[data-chip]").forEach(function(b){b.setAttribute("aria-pressed",b===t)});
    $$("#archGrid .card").forEach(function(c){c.hidden=!(k==="all"||c.dataset.type===k)});
    return;
  }
  if((t=e.target.closest("[data-scroll]"))){
    var el=document.getElementById(t.dataset.scroll);
    if(el){e.preventDefault();el.scrollIntoView({behavior:"smooth",block:"start"});var f=el.querySelector("input");if(f)setTimeout(function(){f.focus({preventScroll:true})},500)}
  }
});
document.addEventListener("keydown",function(e){if(e.key==="Escape") closeOverlays()});

/* ---------- collection filters + sort ---------- */
$$("select[data-nav]").forEach(function(s){s.addEventListener("change",function(){location.href=s.value})});
$$("select[data-sort]").forEach(function(s){s.addEventListener("change",function(){
  var u=new URL(location.href); u.searchParams.set("sort_by",s.value); u.searchParams.delete("page"); location.href=u.toString();
})});
/* mark the active price bucket */
$$("select[data-price]").forEach(function(s){
  var cur=new URLSearchParams(location.search), curP={};
  cur.forEach(function(v,k){if(k.indexOf("filter.v.price")===0) curP[k]=v});
  var keys=Object.keys(curP); if(!keys.length) return;
  Array.prototype.forEach.call(s.options,function(o){
    try{
      var p=new URL(o.value,location.origin).searchParams, op={};
      p.forEach(function(v,k){if(k.indexOf("filter.v.price")===0) op[k]=v});
      var ok=Object.keys(op).length===keys.length&&keys.every(function(k){return parseFloat(op[k])===parseFloat(curP[k])});
      if(ok) o.selected=true;
    }catch(err){}
  });
});

/* ---------- request a piece -> WhatsApp ---------- */
$$("form[data-request-form]").forEach(function(f){
  var pre=f.dataset.pre; if(pre){var sel=f.querySelector("select[name=cat]"); if(sel) sel.value=pre;}
  f.addEventListener("submit",function(e){
    e.preventDefault();
    if(!f.checkValidity()){f.reportValidity();return}
    var d=new FormData(f), cat=d.get("cat")||"", cond=d.get("cond")||"";
    var msg="Hi ALLRED, I'm looking for a Chrome Hearts "+d.get("piece")+(cat?" ("+cat.toLowerCase()+")":"")+
      (d.get("size")?", size "+d.get("size"):"")+(cond?", condition: "+cond.toLowerCase():"")+
      (d.get("budget")?", budget around "+d.get("budget"):"")+". Can you source it?"+
      (d.get("name")?" My name is "+d.get("name")+".":"")+(d.get("contact")?" You can reach me at "+d.get("contact")+".":"");
    window.open(waUrl(msg),"_blank","noopener");
  });
});

/* ---------- sell / trade: show "what are you looking for" only for trades ---------- */
$$('input[name="contact[Intent]"]').forEach(function(r){
  r.addEventListener("change",function(){var t=$("#tradeWant");if(t) t.hidden=(r.value==="Sell")});
});

/* ---------- product gallery counter ---------- */
var g=$("#gal"), n=$("#galN"), dots=$$("#galDots i");
if(g){g.addEventListener("scroll",function(){
  var i=Math.round(g.scrollLeft/Math.max(1,g.clientWidth));
  if(n) n.textContent=i+1;
  dots.forEach(function(d,j){d.classList.toggle("on",j===i)});
},{passive:true})}

/* ---------- mobile buy bar: appears after the main buttons scroll away ---------- */
var bar=$(".pbar"), acts=$(".pactions");
if(bar){
  document.body.classList.add("has-pbar");
  if(acts&&"IntersectionObserver" in window){
    bar.classList.add("off");
    new IntersectionObserver(function(en){bar.classList.toggle("off",en[0].isIntersecting||en[0].boundingClientRect.top>0)}).observe(acts);
  }
}

/* ---------- slow reveal of editorial images and text ---------- */
(function(){
  var els=$$(".rv");
  if(!els.length) return;
  if(!("IntersectionObserver" in window)||matchMedia("(prefers-reduced-motion: reduce)").matches){els.forEach(function(e){e.classList.add("in")});return}
  var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add("in");io.unobserve(x.target)}})},{rootMargin:"0px 0px -6% 0px"});
  els.forEach(function(e){io.observe(e)});
  /* in the theme editor, show everything immediately */
  if(window.Shopify&&Shopify.designMode) els.forEach(function(e){e.classList.add("in")});
})();
document.addEventListener("shopify:section:load",function(e){$$(".rv",e.target).forEach(function(el){el.classList.add("in")})});

paintWish();
})();
